import { render, staticRenderFns } from "./WaybilPurchasedReceipt.vue?vue&type=template&id=2595059c&scoped=true"
import script from "./WaybilPurchasedReceipt.vue?vue&type=script&lang=js"
export * from "./WaybilPurchasedReceipt.vue?vue&type=script&lang=js"
import style0 from "./WaybilPurchasedReceipt.vue?vue&type=style&index=0&id=2595059c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2595059c",
  null
  
)

export default component.exports